import { Button, Input, Modal, Select, Tooltip } from "antd";

import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { savePriseEnCharge, updatePriseEnCharge } from "../../../hooks/useHooks";
import axiosInstance from "../../../variables/api/axiosInstance";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { displayNumbers, formatAmount } from "../../../variables/numbersFunctions";
import AmountInputNumber from "../../../components/inputs/AmountInputNumber";

const initPEC = {
    victime: {},
    etablissement: {},
    natureActe: "",
    codification: "",
    montant: 0,
    delaiValidite: "",
    dureeValidite: "",
    charge: [],
    sousEvaluations: [],
};

const { Option } = Select;

const AjouterPriseEnCharge = (props) => {
    const [modalPEC, setModalPEC] = useState(props?.open);
    const [pec, setPEC] = useState(() => ({ ...initPEC }));
    const [acteModal, setActeModal] = useState(false);
    const [actes, setActes] = useState([]);
    const [natureActes, setNatureActes] = useState([]);
    const [editActe, setEditActe] = useState(false);
    const [selectedActe, setSelectedActe] = useState();

    const [victimeState, setVictimeState] = useState("");
    const [sousEvaluationsState, setSousEvaluationsState] = useState("");
    const [etablissementState, setEtablissementState] = useState("");
    const [natureActeState, setNatureActeState] = useState("");
    const [codificationState, setCodificationState] = useState("");
    const [montantState, setMontantState] = useState("");
    const [delaiValiditeState, setDelaiValiditeState] = useState("");
    const [dvUnit, setDVUnit] = useState("M");
    const [sousEvaluations, setSousEvaluations] = useState([]);
    const [etablissements, setEtablissements] = useState([]);

    const resetModalState = () => {
        setPEC({ ...initPEC });
        setVictimeState("");
        setSousEvaluationsState("");
        setEtablissementState("");
        setNatureActeState("");
        setCodificationState("");
        setMontantState("");
        setDelaiValiditeState("");
        setActes([]);
        setEditActe(false);
        setSelectedActe(undefined);
        setDVUnit("M");
        setActeModal(false);
    };

    const handleCloseModal = () => {
        resetModalState();
        setModalPEC(false);
        props.setOpen && props.setOpen(false);
        props.onClose && props.onClose();
    };

    const isValidated = () => {
        if (
            victimeState === "success" &&
            etablissementState === "success" &&
            delaiValiditeState === "success"
        ) {
            return true;
        } else {
            if (victimeState !== "success") {
                setVictimeState("error");
            }
            if (etablissementState !== "success") {
                setEtablissementState("error");
            }
            if (delaiValiditeState !== "success") {
                setDelaiValiditeState("error");
            }
            return false;
        }
    };

    const [addVictimeLoading, setAddVictimeLoading] = useState(false);

    const addActe = () => {
        setEditActe(false);
        setSelectedActe(undefined);
        setActes((previous) => ([
            ...(previous || []),
            {
                acte: "",
                codificationActe: "",
                montantReclame: 0,
                montantRetenue: 0,
                montantExclu: 0,
            },
        ]));
        setActeModal(true);
    };

    useEffect(() => {
        axiosInstance
            .get(`/api/parametre/type/NATURE_ACTE`)
            .then((res) => {
                // Ranger par ordre alphabetique sur le libelleParametre
                const sorted = res.data.sort((a, b) => a.libelleParametre.localeCompare(b.libelleParametre));
                setNatureActes(sorted);
            })
            .catch((err) => console.error("Erreur récupération natures actes:", err));
    }, []);

    const handleSubmit = async () => {
        const validated = isValidated();
        if (!validated) {
            toast.error("Veuillez remplir tous les champs obligatoires");
            return;
        }
        if (!props?.sinistre?.codeId) {
            toast.error("Sinistre introuvable");
            return;
        }

        const payload = {
            ...pec,
            charge: actes.length > 0 ? actes : null,
        };

        try {
            setAddVictimeLoading(true);
            if (props.edit) {
                await updatePriseEnCharge(payload, props.sinistre.codeId);
                toast.success("Prise en charge mise à jour avec succès !");
            } else {
                await savePriseEnCharge(payload, props.sinistre.codeId);
                toast.success("Prise en charge ajoutée avec succès !");
            }
            resetModalState();
            setModalPEC(false);
            props.setOpen && props.setOpen(false);
            props.onSuccess && props.onSuccess();
            window.location.reload();
        } catch (error) {
            console.error(error);
            toast.error("Une erreur est survenue");
        } finally {
            setAddVictimeLoading(false);
        }
    };
    const handleChange = (e, nom) => {
        if (nom) {
            setPEC((previous) => ({ ...(previous || { ...initPEC }), [nom]: e }));
            return;
        }
        const { name, value } = e.target;
        if (name === "dureeValidite") {
            const nextValue = value === "" ? "" : `${value}${dvUnit}`;
            setPEC((previous) => ({ ...(previous || { ...initPEC }), [name]: nextValue }));
        } else {
            setPEC((previous) => ({ ...(previous || { ...initPEC }), [name]: value }));
        }
    };

    useEffect(() => {
        setModalPEC(props.open);
        if (!props.open) {
            resetModalState();
            return;
        }

        if (props.edit && props.priseEnCharge) {
            try {
                const cloned = JSON.parse(JSON.stringify(props.priseEnCharge));
                const { charge = [], ...rest } = cloned || {};
                setPEC({ ...initPEC, ...rest });
                setActes(Array.isArray(charge) ? charge : []);
                const unit = rest?.dureeValidite ? rest.dureeValidite.slice(-1) : "M";
                setDVUnit(unit || "M");
                setVictimeState("success");
                setEtablissementState("success");
                setDelaiValiditeState(rest?.dureeValidite ? "success" : "");
                setSousEvaluationsState("success");
                if (rest?.natureActe) setNatureActeState("success");
                if (rest?.codification) setCodificationState("success");
                setMontantState("success");
            } catch (error) {
                console.error("Erreur lors du chargement de la prise en charge :", error);
                resetModalState();
            }
        } else {
            resetModalState();
        }
    }, [props.open, props.edit, props.priseEnCharge]);

    useEffect(() => {
        if (!modalPEC) {
            return;
        }
        axiosInstance
            .get(`/api/etablissement`)
            .then((res) => {
                setEtablissements(res.data);
            })
            .catch((err) => {
                console.error("Erreur lors de la récupération des établissements :", err);
            });
        const sev =
            props?.sinistre?.evaluations?.flatMap((item) => item?.sousEvaluations || []) || [];
        setSousEvaluations(sev);
    }, [modalPEC, props.sinistre]);

    const selectAfter = (
        <Select
            defaultValue="M"
            onSelect={(value) => {
                setDVUnit(value);
                setPEC((previous) => {
                    const current = previous || { ...initPEC };
                    const rawDuration = current?.dureeValidite ? parseInt(current.dureeValidite, 10) : NaN;
                    if (Number.isNaN(rawDuration)) {
                        return { ...current };
                    }
                    return { ...current, dureeValidite: `${rawDuration}${value}` };
                });
            }}
            value={dvUnit}
        >
            <Option value="M">Mois</Option>
            <Option value="J">Jour(s)</Option>
            <Option value="A">Année(s)</Option>
            <Option value="H">Heure(s)</Option>
        </Select>
    );

    return (
        <Modal
            title={props.edit ? "Modifier une prise en charge" : "Ajouter une prise en charge"}
            centered
            open={modalPEC}
            onOk={handleSubmit}
            onCancel={handleCloseModal}
            confirmLoading={addVictimeLoading}
            width={1000}
            okText={props.edit ? "Modifier" : "Ajouter"}
            cancelText="Annuler"
        >
            <div className="row" >
                <div className="col-6">
                    <label
                        htmlFor="victime"
                        style={{
                            margin: "30px 0 10px 0",
                            color: victimeState === "error" ? "red" : null,
                        }}
                    >
                        *Victime :
                    </label>
                    <div>
                        <Select
                            id="victime"
                            name="victime"
                            style={{ width: "100%" }}
                            placeholder="Sélectionnez la victime"
                            options={(props?.sinistre?.victimes || []).map((item) => ({
                                value: JSON.stringify(item),
                                label: [item?.personne?.nom, item?.personne?.prenom]
                                    .filter(Boolean)
                                    .join(" ") || item?.personne?.nom,
                            }))}
                            value={pec?.victime && Object.keys(pec.victime || {}).length
                                ? JSON.stringify(pec.victime)
                                : undefined}
                            onChange={(value) => {
                                if (!value) {
                                    handleChange({}, "victime");
                                    setVictimeState("error");
                                    return;
                                }
                                handleChange(JSON.parse(value), "victime");
                                setVictimeState("success");
                            }}
                            optionFilterProp="label"
                            allowClear
                        />
                    </div>
                </div>
                <div className="col-6">
                    <label
                        htmlFor="etablissement"
                        style={{
                            margin: "30px 0 10px 0",
                            color: etablissementState === "error" ? "red" : null,
                        }}
                    >
                        *Etablissement :
                    </label>
                    <div>
                        <Select
                            id="etablissement"
                            name="etablissement"
                            placeholder="Sélectionnez l'établissement"
                            style={{ width: "100%" }}
                            options={etablissements.map((item) => ({
                                value: JSON.stringify(item),
                                label: item?.nom,
                            }))}
                            value={pec?.etablissement && Object.keys(pec.etablissement || {}).length
                                ? JSON.stringify(pec.etablissement)
                                : undefined}
                            onChange={(value) => {
                                if (!value) {
                                    handleChange({}, "etablissement");
                                    setEtablissementState("error");
                                    return;
                                }
                                handleChange(JSON.parse(value), "etablissement");
                                setEtablissementState("success");
                            }}
                            optionFilterProp="label"
                            allowClear
                        />
                    </div>
                </div>
                <div className="col-6">
                    <label
                        htmlFor="natureActe"
                        style={{
                            margin: "30px 0 10px 0",
                            // color: natureActeState === "error" ? "red" : null,
                        }}
                    >
                        La nature de l'acte:
                    </label>
                    <Input
                        id="natureActe"
                        name="natureActe"
                        value={pec?.natureActe}
                        placeholder="Nature de l'acte de la prise en charge"
                        status={natureActeState === "error" ? "error" : null}
                        onChange={(event) => {
                            handleChange(event);
                            if (event.target.value.length > 3) {
                                setNatureActeState("success");
                            } else {
                                setNatureActeState("error");
                            }
                        }}
                    />
                </div>
                <div className="col-6">
                    <label
                        htmlFor="codification"
                        style={{
                            margin: "30px 0 10px 0",
                            // color: codificationState === "error" ? "red" : null,
                        }}
                    >
                        Codification de l'acte
                    </label>
                    <Input
                        id="codification"
                        name="codification"
                        value={pec?.codification}
                        type="text"
                        placeholder="Codification de l'acte"
                        status={codificationState === "error" ? "error" : null}
                        onChange={(event) => {
                            handleChange(event);
                            if (event.target.value.length > 3) {
                                setCodificationState("success");
                            } else {
                                setCodificationState("error");
                            }
                        }}
                    />
                </div>

                <div className="col-6">
                    <label
                        htmlFor="montant"
                        style={{
                            margin: "30px 0 10px 0",
                            color: montantState === "error" ? "red" : null,
                        }}
                    >
                        Coût de l'acte:
                    </label>
                    <Input
                        id="montant"
                        name="montant"
                        value={formatAmount(pec?.montant)}
                        type="text"
                        placeholder="Coût de l'acte"
                        status={montantState === "error" ? "error" : null}
                        onChange={(event) => {
                            handleChange(event);
                            if (event.target.value.length > 3) {
                                setMontantState("success");
                            } else {
                                setMontantState("error");
                            }
                        }}
                        disabled={true}
                    />
                </div>

                <div className="col-6">
                    <label
                        htmlFor="dureeValidite"
                        style={{
                            margin: "30px 0 10px 0",
                            color: delaiValiditeState === "error" ? "red" : null,
                        }}
                    >
                        *Delai de validité:
                    </label>
                    <Input
                        id="dureeValidite"
                        name="dureeValidite"
                        value={pec?.dureeValidite ? parseInt(pec.dureeValidite, 10) : undefined}
                        placeholder="Delai de validité"
                        type="number"
                        status={delaiValiditeState === "error" ? "error" : null}
                        addonAfter={selectAfter}
                        onChange={(event) => {
                            handleChange(event);
                            setDelaiValiditeState("success");
                        }}
                    />
                </div>
                <br />
                *Les différents actes de cette prise en charge:

                <br />
                <br />
                <table class="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            <th scope="col-5">Acte</th>
                            <th scope="col-2">Montant réclamé</th>
                            <th scope="col-2">Montant retenu</th>
                            <th scope="col-2">Montant exclu</th>
                            <th scope="col-1">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {actes.map((item, index) => {
                            const montantReclame = Number(item?.montantReclame || 0);
                            const montantExclu = Number(item?.montantExclu || 0);
                            const montantRetenue = Number(
                                item?.montantRetenue !== undefined && item?.montantRetenue !== null
                                    ? item.montantRetenue
                                    : montantReclame - montantExclu
                            );
                            return (
                                <tr key={index}>
                                    <td>{item?.acte}</td>
                                    <td>{displayNumbers(item?.montantReclame)}</td>
                                    <td>{displayNumbers(item?.montantRetenue ? item?.montantRetenue : item?.montantReclame - item?.montantExclu)}</td>
                                    <td>{displayNumbers(item?.montantExclu)}</td>
                                    <td>
                                        <Tooltip title="Modifier">
                                            <Button type="primary" onClick={() => {
                                                setSelectedActe(index);
                                                setEditActe(true);
                                                setActeModal(true);
                                            }} style={{ backgroundColor: "gray" }} shape="circle" icon={<EditOutlined />} />
                                        </Tooltip>
                                        <Tooltip title="Supprimer">
                                            <Button type="primary" onClick={() => {
                                                setActes((previous) => {
                                                    const next = [...previous];
                                                    next.splice(index, 1);
                                                    const totalRetenu = next.reduce(
                                                        (acc, acte) => acc + Number(acte?.montantRetenue || 0),
                                                        0
                                                    );
                                                    setPEC((prev) => ({ ...(prev || { ...initPEC }), montant: totalRetenu }));
                                                    return next;
                                                });
                                                toast.success("Acte supprimé avec succès");
                                            }} style={{ backgroundColor: "red" }} shape="circle" icon={<DeleteOutlined />} />
                                        </Tooltip>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <div class="col-6">
                    <button
                        type="button"
                        class="btn btn-primary"
                        onClick={() => addActe()}
                    >
                        <span
                            class="tf-icons bx bx-folder-plus bx-18px me-2"></span>
                        Ajouter un acte
                    </button>
                </div>
            </div>
            <Modal
                title={editActe ? "Modifier l'acte" : "Ajouter un acte"}
                centered
                open={acteModal}
                onOk={() => {
                    const targetIndex = editActe ? selectedActe : actes.length - 1;
                    if (targetIndex === undefined || targetIndex < 0) {
                        setActeModal(false);
                        setEditActe(false);
                        setSelectedActe(undefined);
                        return;
                    }
                    const newActes = [...actes];
                    const currentActe = { ...newActes[targetIndex] };
                    const montantReclame = Number(currentActe?.montantReclame || 0);
                    const montantRetenue = Number(currentActe?.montantRetenue || 0);
                    currentActe.montantReclame = montantReclame;
                    currentActe.montantRetenue = montantRetenue;
                    currentActe.montantExclu = montantReclame - montantRetenue;
                    newActes[targetIndex] = currentActe;
                    const totalRetenu = newActes.reduce(
                        (acc, item) => acc + Number(item?.montantRetenue || 0),
                        0
                    );
                    setPEC((previous) => ({ ...(previous || { ...initPEC }), montant: totalRetenu }));
                    setActes(newActes);
                    setActeModal(false);
                    setEditActe(false);
                    setSelectedActe(undefined);
                }}
                onCancel={() => {
                    if (!editActe) {
                        setActes((previous) => previous.slice(0, -1));
                    }
                    setActeModal(false);
                    setEditActe(false);
                    setSelectedActe(undefined);
                }}
                zIndex={1000}
                okText={editActe ? "Modifier" : "Ajouter"}
                cancelText="Annuler"
            >
                <form>
                    <div className="row" >
                        <div className="col-12">
                            <label
                                htmlFor="acte"
                                style={{
                                    margin: "30px 0 10px 0",
                                }}
                            >
                                Acte:
                            </label>
                            <Select
                                style={{
                                    width: "100%",
                                }}
                                showSearch
                                id="acte"
                                name="acte"
                                value={actes[editActe ? selectedActe : actes.length - 1]?.acte}
                                placeholder="Acte de la prise en charge"
                                onChange={(value) => {
                                    const newActes = [...actes];
                                    newActes[editActe ? selectedActe : actes.length - 1].acte = value;
                                    setActes(newActes);
                                }}
                                options={natureActes?.map((na) => ({ label: na.libelleParametre, value: na.libelleParametre }))}
                            />
                        </div>
                        <div className="col-6">
                            <label
                                htmlFor="montantReclame"
                                style={{
                                    margin: "30px 0 10px 0",
                                }}
                            >
                                Montant réclamé:
                            </label>
                            <AmountInputNumber
                                id="montantReclame"
                                name="montantReclame"
                                value={actes[editActe ? selectedActe : actes.length - 1]?.montantReclame}
                                placeholder="Montant réclamé"
                                min={0}
                                style={{ width: "100%" }}
                                onChange={(value) => {
                                    const newActes = [...actes];
                                    newActes[editActe ? selectedActe : actes.length - 1].montantReclame = Number(value ?? 0);
                                    setActes(newActes);
                                }}
                            />
                        </div>
                        <div className="col-6">
                            <label
                                htmlFor="montantRetenu"
                                style={{
                                    margin: "30px 0 10px 0",
                                }}
                            >
                                Montant retenu:
                            </label>
                            <AmountInputNumber
                                id="montantRetenue"
                                name="montantRetenue"
                                value={actes[editActe ? selectedActe : actes.length - 1]?.montantRetenue}
                                placeholder="Montant retenu"
                                min={0}
                                style={{ width: "100%" }}
                                onChange={(value) => {
                                    const newActes = [...actes];
                                    newActes[editActe ? selectedActe : actes.length - 1].montantRetenue = Number(value ?? 0);
                                    setActes(newActes);
                                }}
                            />
                        </div>
                        <div className="col-6">
                            <label
                                htmlFor="montantExclu"
                                style={{
                                    margin: "30px 0 10px 0",
                                }}
                            >
                                Montant exclu: {displayNumbers(actes[editActe ? selectedActe : actes.length - 1]?.montantReclame - actes[editActe ? selectedActe : actes.length - 1]?.montantRetenue)}
                            </label>
                        </div>
                    </div>
                </form>
            </Modal>
        </Modal>
    );
};

AjouterPriseEnCharge.propTypes = {
    open: PropTypes.bool,
    priseEnCharge: PropTypes.object,
    edit: PropTypes.bool,
    setOpen: PropTypes.func,
    sinistre: PropTypes.object,
    onSuccess: PropTypes.func,
    onClose: PropTypes.func,
};

export default AjouterPriseEnCharge;
